import React from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import AdminUserEditProfileEdit from './ProfileEdit';
import AdminUserEditPasswordChange from './PasswordChange';
import AdminUserEdit2FA from './2FA';
import AdminUserEditPermissions from './Permissions';
import AdminUserEditNotifications from './Notifications';
import AdminUserEditShareSettings from './ShareSettings';
import AdminUserEditPrefixSuffix from './PrefixSuffix';
import AdminUserEditAPIAccess from './APIAccess';

const AdminUserEditTabContent = (props) => {
  const { activeTab } = props;

  return (
    <TabContent activeTab={activeTab} className="settings-tab-content">
      <TabPane tabId="profile">
        <AdminUserEditProfileEdit
          {...props}
        />
      </TabPane>
      <TabPane tabId="password">
        <AdminUserEditPasswordChange
          {...props}
        />
      </TabPane>
      <TabPane tabId="2fa">
        <AdminUserEdit2FA
          {...props}
        />
      </TabPane>
      <TabPane tabId="permissions">
        <AdminUserEditPermissions
          {...props}
        />
      </TabPane>
      <TabPane tabId="notifications">
        <AdminUserEditNotifications
          {...props}
        />
      </TabPane>
      <TabPane tabId="share-settings">
        <AdminUserEditShareSettings
          {...props}
        />
      </TabPane>
      <TabPane tabId="prefix-and-suffix">
        <AdminUserEditPrefixSuffix
          {...props}
          showUpgradeButton={false}
        />
      </TabPane>
      <TabPane tabId="api-access">
        <AdminUserEditAPIAccess
          {...props}
          showUpgradeButton={false}
        />
      </TabPane>
    </TabContent>
  );
};

AdminUserEditTabContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
};

export default AdminUserEditTabContent;
